<template>
	<div class="company-detail-wrapper">
		<div class="company-detail-top">
			<div class="company-logo-container">
				<img :src="company.logo" class="company-logo" />
			</div>
			<div class="nav-wrapper">
				<div class="prev">
					<div v-if="prev">
						<router-link :to="prevUrl" class="link">
							<img
								src="./../assets/img/arrow-left.svg"
								class="arrow"
							/>
							<span class="name">{{ prev.name }}</span>
						</router-link>
					</div>
				</div>
				<div class="title">
					<h1 class="name">{{ company.name }}</h1>
					<div class="investedDate">
						Invested in {{ company.investedDate }}
					</div>
				</div>
				<div class="next">
					<div v-if="next">
						<router-link :to="nextUrl" class="link">
							<span class="name">{{ next.name }}</span>
							<img
								src="./../assets/img/arrow-left.svg"
								class="arrow"
							/>
						</router-link>
					</div>
				</div>
			</div>
			<div class="description">
				{{ company.description }}
			</div>
		</div>
		<hr class="hr" />
		<div class="news-wrapper">
			<div class="news-header">
				<div class="news-header-label">IN THE NEWS</div>
				<div class="social-links-container">
					<a v-if="company.instagramUrl" :href="company.instagramUrl"
						>IG</a
					>
					<a v-if="company.twitterUrl" :href="company.twitterUrl"
						>TW</a
					>
					<a v-if="company.webUrl" :href="company.webUrl">WEB</a>
				</div>
			</div>
			<ul class="news-items">
				<li v-for="item in company.news" class="news-item">
					<a class="news-item-link" :href="item.url">
						<div class="headline">{{ item.headline }}</div>
						<div class="source-wrapper">
							<span class="source">{{ item.source }}</span>
							<span class="date">{{ item.date }}</span>
						</div>
					</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
export default {
	name: "CompanyDetail",
	props: {
		slug: String,
		companies: Array
	},
	watch: {
		companies: function() {
			this.updateCompany();
		}
	},
	computed: {
		prevUrl: function() {
			return `/companies/${this.prev.slug}`;
		},
		nextUrl: function() {
			return `/companies/${this.next.slug}`;
		}
	},
	data: function() {
		const self = this;
		const company = this.companies.find(function(item) {
			return item.slug === self.slug;
		});
		const index = this.companies.indexOf(company);
		let prevIndex = index - 1;
		if (prevIndex < 0) {
			prevIndex = this.companies.length - 1;
		}
		let nextIndex = index + 1;
		if (nextIndex > this.companies.length - 1) {
			nextIndex = 0;
		}
		return {
			company: company || {},
			prev: this.companies[prevIndex],
			next: this.companies[nextIndex]
		};
	},
	methods: {
		updateCompany(slug) {
			const self = this;
			slug = slug || this.slug;
			this.company = this.companies.find(function(item) {
				return item.slug === slug;
			});
			const index = this.companies.indexOf(this.company);
			let prevIndex = index - 1;
			if (prevIndex < 0) {
				prevIndex = this.companies.length - 1;
			}
			let nextIndex = index + 1;
			if (nextIndex > this.companies.length - 1) {
				nextIndex = 0;
			}
			this.prev = this.companies[prevIndex];
			this.next = this.companies[nextIndex];
		}
	},
	beforeRouteUpdate(to) {
		console.log("this.slug", this.slug, to);
		this.updateCompany(to.params.slug);
	}
};
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.company-detail-wrapper {
}
.company-detail-top {
	min-height: 66vh;
}
.hr {
	position: absolute;
	left: 0;
	right: 0;
	transform: scaleY(0.65);
}
.company-logo-container {
	height: 8rem;
	text-align: center;
	margin-bottom: 8rem;

	.company-logo {
		height: 100%;
	}
}

.nav-wrapper {
	display: flex;

	.prev,
	.next {
		font-size: 1rem;
		font-family: $font-national;
		font-weight: 500;
		text-transform: uppercase;
		color: $color-gray;
		line-height: 6.2;

		.link {
			text-decoration: none;
			display: flex;
			align-items: center;

			&:hover {
				.name {
					opacity: 1;
				}
			}
		}

		.name {
			padding: 0 1em;
			opacity: 0;
			transition: opacity 0.3s ease;
			letter-spacing: 0.1em;
		}

		.arrow {
			height: 1.6rem;
		}
	}
	.title {
		flex-grow: 1;
		text-align: center;

		.name {
			font-size: 4.2rem;
			text-align: center;
			font-weight: normal;
			margin: 0;
		}

		.investedDate {
			font-size: 1rem;
			font-family: $font-national;
			font-weight: 500;
			text-transform: uppercase;
			letter-spacing: 0.1em;
		}
	}
	.next {
		.arrow {
			transform: rotate(180deg);
		}
	}
}
.description {
	margin: 3em 0 0;
	font-size: 1.8rem;
	font-family: $font-national;
}
.news-wrapper {
	margin: 5rem 0 0;

	.news-header {
		display: flex;
		justify-content: space-between;
		font-size: 1rem;
		font-family: $font-national;
		font-weight: 500;
		text-transform: uppercase;
		margin-bottom: 4em;
	}
	.social-links-container a {
		margin-left: 1.5em;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
	.news-header-label {
		letter-spacing: 0.1em;
	}
}
.news-items {
	list-style: none;
	padding: 0;
	margin: 0;
}

.news-item {
	&:hover .headline {
		text-decoration: underline;
	}
	.news-item-link {
		text-decoration: none;
	}

	.headline {
		font-size: 1.8rem;
		line-height: 1.5;
		font-family: $font-national;
		text-decoration: none;
		margin-bottom: 0.25em;
	}

	.source-wrapper {
		font-size: 1rem;
		line-height: 1.5;
		font-family: $font-national;
		font-weight: 500;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CompanyDetail.vue